// extracted by mini-css-extract-plugin
export default {"description":"WymwA","skeleton-progress":"giIbL"};